var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"0px","margin-left":"0"}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-breadcrumbs',{attrs:{"items":_vm.items,"divider":">"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }